module.exports = __webpack_public_path__ + "Safari-adcfd58af599932f75f36e97bdaa7021.png";


//////////////////
// WEBPACK FOOTER
// ./assets/browser-icons/Safari.png
// module id = 1131
// module chunks = 0 1